import moment from 'moment'
import { formatAttachments } from '../attachments/formatAttachments'
function getMetadata (metadata) {
  if (metadata.length > 0) {
    return {
      isRead: metadata[0].isRead,
      isAcknowledged: metadata[0].isAcknowledged
    }
  }

  return {
    isRead: false,
    isAcknowledged: false
  }
}

function getRecipients (recipients) {
  if (recipients.length > 0) console.debug('getRecipients', recipients)
  const formatRecipients = []
  recipients.forEach(({ section }) => {
    const foundLevel = formatRecipients.find(p => p.id === section.section.level.id)
    if (foundLevel) foundLevel.sections.push({ id: section.id, name: section.name })
    else {
      formatRecipients.push({
        id: section?.section?.level?.id,
        name: section?.section?.level?.name,
        sections: [
          {
            id: section.id,
            name: section.name
          }
        ]
      })
    }
  })
  return formatRecipients
}

export function formatAnnouncementList (announcements) {
  return announcements.map(announcement => {
    return {
      id: announcement.id,
      title: announcement.content.title,
      sender: {
        id: announcement.senderUser.id,
        email: announcement.senderUser.email
      },
      metadata: getMetadata(announcement.metadata),
      date: moment(announcement.createdAt).format('MMM DD, YYYY'),
      timestamp: moment(announcement.createdAt).format('hh:mm a'),
      sec: moment(announcement.createdAt).format('ss')
    }
  })
}

export function formatAnnouncement (announcement) {
  return {
    id: announcement.id,
    contentId: announcement.content.id,
    title: announcement.content.title,
    body: announcement.content.body,
    attachments: formatAttachments(announcement.content.attachments.map(attachment => attachment.asset)),
    sender: {
      id: announcement.senderUser.id,
      email: announcement.senderUser.email
    },
    recipients: getRecipients(announcement.recipients),
    requireAcknowledge: announcement.data.requireAcknowledge || false,
    forParents: announcement.data.forParents || false,
    metadata: getMetadata(announcement.metadata),
    date: moment(announcement.createdAt).format('MMM DD, YYYY'),
    timestamp: moment(announcement.createdAt).format('hh:mm a'),
    sec: moment(announcement.createdAt).format('ss')
  }
}
